import { addSeconds } from '../DateUtils';
import { timeout } from '../ChoiceUtils';

export class Debounce
{
    eventTimestamp?: Date;
    blackOutTimeInSeconds: number;

    public constructor(blackOutTimeInSeconds: number)
    {
        this.blackOutTimeInSeconds = blackOutTimeInSeconds;
    }

    public isBlocked(): boolean
    {
        if (this.eventTimestamp)
        {
            if(new Date() < addSeconds(this.eventTimestamp, this.blackOutTimeInSeconds))
                return true;
            this.eventTimestamp = undefined;
            return false;
        }

        this.eventTimestamp = new Date();
        return false;
    }

    public reset(resetDelay: number = 1000): void
    {
        timeout(resetDelay)
            .then(() => this.eventTimestamp = undefined);
    }
}